import { defineComponent, openBlock, createElementBlock } from 'vue';
import './addProcess.mjs';
import { DistrictCluster } from '@vuemap/district-cluster';
import '../../../../mixins/index.mjs';
import { buildProps } from '../../../../utils/buildHelper.mjs';
import { useRegister } from '../../../../mixins/useRegister.mjs';

var script = /* @__PURE__ */ defineComponent({
  ...{
    name: "ElAmapLayerDistrictCluster",
    inheritAttrs: false
  },
  __name: "DistrictCluster",
  props: buildProps({
    data: {
      required: true,
      type: Array
    },
    // 数据源数组，每个元素即为点相关的信息
    getPosition: {
      type: Function
    },
    // 返回数据项中的经纬度信息
    autoSetFitView: {
      type: Boolean,
      default: true
    },
    // 是否在绘制后自动调整地图视野以适合全部点，默认true
    topAdcodes: {
      type: Array
    },
    // 顶层区划的adcode列表
    excludedAdcodes: {
      type: Array
    },
    renderOptions: {
      type: Object
    }
    // 绘制的引擎的参数
  }),
  emits: ["init"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emits = __emit;
    let $amapComponent;
    const { $$getInstance } = useRegister((options, parentComponent) => {
      return new Promise((resolve) => {
        options.map = parentComponent;
        $amapComponent = new DistrictCluster(options);
        resolve($amapComponent);
      });
    }, {
      emits,
      destroyComponent() {
        if ($amapComponent) {
          $amapComponent.destroy();
          $amapComponent = null;
        }
      }
    });
    __expose({
      $$getInstance
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div");
    };
  }
});

export { script as default };
//# sourceMappingURL=DistrictCluster.vue2.mjs.map
